import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// const accesToken = `Bearer ${localStorage.getItem("access")}`;
export const loginService = createApi({
  reducerPath: "loginService",
  tagTypes: ["login"],
  baseQuery: fetchBaseQuery({ baseUrl: "https://api.upswap.app/api" }),
  endpoints: (builder) => ({
      loginUser: builder.mutation({
      invalidatesTags: ["login"],
      query: (newPost) => ({
        url: "/login/",
        method: "POST",
        body: newPost,
      }),
    }),

  }),
});

export const {
    useLoginUserMutation
 
} = loginService;
export default loginService;